/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import ForgotPasswordSuccessDumb from './ForgotPasswordSuccessDumb';
import { getAuthenticationUsername } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';

const mapStateToProps = (state: Object): Object => ({
  username: getAuthenticationUsername(state),
});

export default compose(connect(mapStateToProps))(ForgotPasswordSuccessDumb);
